import { Identify } from '@amplitude/analytics-browser';
import { Amplitude } from './ampitude';
import { os } from '@/shared/constants/_rtc/utils/isUnsupportedBrowser';
import { isMobile } from '@/shared/utils/isMobile';

const getUserIdentifyPayload = (user) => ({
  id: user.id,
  language: user.language,
  role: user.role,
  tariff: user.subscription?.tariffName ?? 'basic',
  environment: 'web',
  os: os.name,
  device_type: isMobile() ? 'mobile' : 'desktop',
  time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
});

export const identifyUser = async (user = {}) => {
  try {
    const identifyEvent = new Identify();

    for (const [key, value] of Object.entries(getUserIdentifyPayload(user))) {
      identifyEvent.set(key, value);
    }

    await Amplitude.setUserId(user.id);
    await Amplitude.identify(identifyEvent);
  } catch (e) {
    console.error('Failed to identify user. ', e);
  }
};
